import React, {useState} from 'react';
import {messageBoxError, messageBoxSuccess} from '@deviceinsight/ng-ui-components';
import {Button, Modal} from '@deviceinsight/ng-ui-basic-components';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

import {createCustomDatapoint} from '../../api/customDatapointsApi';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import TextInput from './TextInput';

type Props = {
	asset: Asset;
	setLoading: (loading: boolean) => void;
	setCreateModalIsOpen: (modalOpen: boolean) => void;
	loadCustomDps: () => void;
};

const CreateCustomDatapointModal = ({asset, setLoading, setCreateModalIsOpen, loadCustomDps}: Props) => {
	const [newDpName, setNewDpName] = useState<string>();
	const [newDpValue, setNewDpValue] = useState<number>();

	const createCustomDp = () => {
		if (newDpName) {
			const dpVal = newDpValue ? newDpValue : 0;
			const customDpObj = {
				name: newDpName,
				value: dpVal
			};
			setLoading(true);
			createCustomDatapoint(asset.urn, customDpObj)
				.then(() => {
					setCreateModalIsOpen(false);
					setNewDpName('');
					setNewDpValue(undefined);
					messageBoxSuccess(
						<Trans i18nKey="customDatapoints.createCustomDp.customDpCreationSuccess">
							Custom Datapoint was created
						</Trans>
					);
					loadCustomDps();
				})
				.catch(() =>
					messageBoxError(
						<Trans i18nKey="customDatapoints.createCustomDp.couldntCreateCustomDpMsg">
							Custom Datapoint could not be created!
						</Trans>
					)
				)
				.finally(() => setLoading(false));
		} else {
			messageBoxError(
				<Trans i18nKey="customDatapoints.createCustomDp.couldntCreateCustomDpMsg">
					Custom Datapoint could not be created!
				</Trans>
			);
		}
	};

	return (
		<Modal
			width={600}
			header={<Trans i18nKey="customDatapoints.createCustomDp.header">Create Custom Datapoint</Trans>}
			content={
				<>
					<div className="create-modal">
						<label>
							<Trans i18nKey="customDatapoints.createCustomDp.name">Name:</Trans>
						</label>
						<TextInput
							type="text"
							value={newDpName}
							maxLength={32}
							data-testid="newDpName"
							required
							onChange={(e) => setNewDpName(e)}></TextInput>
					</div>
					<div className="create-modal">
						<label>
							<Trans i18nKey="customDatapoints.createCustomDp.value">Value:</Trans>
						</label>
						<TextInput
							type="number"
							value={newDpValue}
							maxLength={32}
							defaultValue="0.0"
							data-testid="newDpValue"
							step="1"
							pattern="\d+"
							required
							onChange={(e) => setNewDpValue(parseFloat(e))}></TextInput>
					</div>
				</>
			}
			footer={
				<>
					<Button primary onClick={createCustomDp} disabled={!newDpName}>
						<Trans i18nKey="customDatapoints.createCustomDp.createButton">Create</Trans>
					</Button>
					<Button
						onClick={() => {
							setCreateModalIsOpen(false);
							setNewDpName('');
							setNewDpValue(undefined);
						}}>
						<Trans i18nKey="customDatapoints.createCustomDp.abortButton">Abort</Trans>
					</Button>
				</>
			}
		/>
	);
};

export default CreateCustomDatapointModal;
